import React from 'react'

export const Hero = () => {
  return (
    <div className='container-fluid hero-container'>
        <img src="/images/tronco.webp" alt="" />
    </div>
  )
}
